const DATE_START_INDEX = 0;
const DATE_DAY_START_INDEX = 3; // (Note: the / is at index 2)
const DATE_YEAR_START_INDEX = 6; // (Note: the / is at index 5)
const DATE_END_INDEX = 10;

export const DATE_SEGMENTS = [
  { start: DATE_START_INDEX, end: DATE_DAY_START_INDEX - 1 },
  { start: DATE_DAY_START_INDEX, end: DATE_YEAR_START_INDEX - 1 },
  { start: DATE_YEAR_START_INDEX, end: DATE_END_INDEX },
] as const;

export const getDateSegmentIndex = (cursorPos: number): number => {
  if (cursorPos <= DATE_DAY_START_INDEX - 1) {
    return 0; // Month segment
  }
  if (cursorPos <= DATE_YEAR_START_INDEX - 1) {
    return 1; // Day segment
  }
  return 2; // Year segment
};

export const selectDateSegment = (input: HTMLInputElement, segmentIndex: number): void => {
  const segment = DATE_SEGMENTS[segmentIndex];
  if (!segment) {
    return;
  }
  input.setSelectionRange(segment.start, segment.end);
};

export const getAdjacentSegmentIndex = (current: number, direction: 'prev' | 'next'): number => {
  const count = DATE_SEGMENTS.length;
  if (direction === 'next') {
    return (current + 1) % count;
  }
  return (current - 1 + count) % count;
};

export const isDateSegmentComplete = (dateValue: string, segmentIndex: number): boolean => {
  const segment = DATE_SEGMENTS[segmentIndex];
  if (!segment) {
    return false;
  }
  const slice = dateValue.slice(segment.start, segment.end);
  const expectedLength = segment.end - segment.start;
  return slice.length === expectedLength && /^\d+$/.test(slice);
};
